import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../models/api-response';
import { Faq } from '../models/faq';
import { HttpHeaders } from '@angular/common/http';
import { List } from '../models/list';
import { Pagination } from '../models/pagination';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class FaqService {

  endpoint: string;

  constructor(
    private baseService: BaseService,
    private authSvc: AuthService
  ) {
    this.endpoint = 'faqs';
  }

  public getAll(productId: string, pagination?: Pagination, filter?: {}): Observable<ApiResponse<List<Faq>>> {
    return this.baseService.getAll<List<Faq>>(this.endpoint, { params: Object.assign({}, pagination, filter, !!productId ? { productId: productId } : {}) })
    .pipe(map(data => {
      data.payload.elements.forEach(e => {
        if (!e.id) {
          e.id = e._id;
        }
      });
      return data;
    }));
  }

  public get(id: string): Observable<ApiResponse<Faq>> {
    return this.baseService.get<Faq>(`${this.endpoint}/${id}`);
  }

  public add(faq: Faq): Observable<ApiResponse<Faq>> {
    return this.baseService.add<Faq>(this.endpoint, faq);
  }

  public update(id: string, faq: Faq): Observable<ApiResponse<Faq>> {
    return this.baseService.update<Faq>(`${this.endpoint}/${id}`, faq);
  }

  public delete(id: string): Observable<ApiResponse<Faq>> {
    return this.baseService.delete<Faq>(`${this.endpoint}/${id}`);
  }

  public show(id: string): Observable<ApiResponse<Faq>> {
    return this.baseService.add<Faq>(`${this.endpoint}/${id}/show`);
  }

  public hide(id: string): Observable<ApiResponse<Faq>> {
    return this.baseService.add<Faq>(`${this.endpoint}/${id}/hide`);
  }

  public addLike(id: string): Observable<ApiResponse<Faq>> {
    // FIXME: pass a flag require auth and let BaseService + TokenInterceptor handle authorization headers
    // Force auth token for frontend requests
    let headers = new HttpHeaders().append('Authorization', `Bearer ${this.authSvc.getCurrentToken()}`);

    return this.baseService.add<Faq>(`${this.endpoint}/${id}/like`, null, headers);
  }

  public deleteLike(id: string): Observable<ApiResponse<Faq>> {
    // FIXME: pass a flag require auth and let BaseService + TokenInterceptor handle authorization headers
    // Force auth token for frontend requests
    let headers = new HttpHeaders().append('Authorization', `Bearer ${this.authSvc.getCurrentToken()}`);

    return this.baseService.delete<Faq>(`${this.endpoint}/${id}/like`, headers);
  }

  public updateAsset(id: string, assetId: string, file: File): Observable<ApiResponse<Faq>> {
    let formData: FormData = new FormData();
    formData.append('file', file, file.name);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    return this.baseService.add<Faq>(`${this.endpoint}/${id}/assets/${assetId}`, formData, headers);
  }
}
